<template lang="pug">
  .wrapper
    
    side-bar
      template(slot='links')
        //sidebar-item(:link="{ name: 'Dashboard', path: '/dashboard',  icon: 'fa fa-columns text-primary'  }")
        
  
        sidebar-item(:link="{ name: 'Projekte', path: '/dashboard',  icon: 'fa fa-folder-tree text-primary' }")
      template(slot='links-after')
       
        
        hr.my-3.mt-4  
        .text-muted.small
        
          span.mb-1(v-for="job in jobs", :key="job._id")
          
            
            .d-flex.justify-content-between
              div.w-100
              
                div.small(v-b-popover.hover.rightbottom="job.owner.email + ' ' + job.created_at")  {{job.project_name}} / {{ job.configuration.project_directory }} 
                  template(v-if="job.total_documents") ({{ job.progress }} / {{job.total_documents}})
                  template(v-else) (Berechne Gesamtzahl)
                b-progress(:value="job.progress" :max="job.total_documents" variant="info" height="5px" :animated="job.progress < 100").w-100
              div
                .float-right
                  b-button(variant="link" size="sm" @click="abortJob(job)").ml-2
                    i.fas.fa-times
        
        hr.my-3.mt-4(v-if="jobs && jobs.length > 0")
        h6.navbar-heading.p-0.text-muted 
        b-nav.navbar-nav.mb-md-3
          // , v-if="$auth && $auth.user && $auth.user.relations && $auth.user.relations.is_admin"
          b-nav-item(to='/keywords').small 
        
            .small  Keyword-Einstellung
          
          b-nav-item(@click="openVGBInfo()").small 
            .small VGB-Info
            
          b-nav-item(@click="logout()").small
            
            .small Ausloggen

          .small.ml-3.mt-5
            .small Version 2026-02-01

          
          
          
    .main-content
      dashboard-navbar(:type='$route.meta.navbarType')
      div(@click='$sidebar.displaySidebar(false)')
        fade-transition(:duration='200' origin='center top' mode='out-in')
          // your content here
          router-view
      content-footer(v-if='!$route.meta.hideFooter')

</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    data: () => ({
      jobs: null
    }),
    components: {
      DashboardNavbar,
      ContentFooter,
      DashboardContent,
      FadeTransition
    },
    methods: {
      abortJob(job) {
        if(confirm("Wollen Sie den Job wirklich abbrechen?")) {
          this.axios.delete(this.base_url + '/job/'+ job._id).then((response) => { 
            this.fechJobs();
          });
        }

      },

      openVGBInfo() {
        window.open('https://dorniergroup.sharepoint.com/:x:/r/sites/-EXT-KiDo-Docs/Freigegebene%20Dokumente/documentation/VGB-S-832-00-2016-04-DE-EN%20DCC%203.xlsx?d=w6fd1bebd4c2a4ae8837a1632ae42f7da&csf=1&web=1&e=NrAnoH', '_blank');
      },

      getCurrentDay() {
        return new Date().toISOString().split('T')[0];
      },

      logout() {
        localStorage.removeItem('auth');
        this.$router.push({"path": "/users/login"});
        //window.location.reload();
      },
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      },
      fechJobs() {
        this.axios.get(this.base_url + '/jobs?status=IN_PROGRESS').then((response) => { 
          this.jobs = response.data;       
        });
      }

    },
    mounted() {
      if(!localStorage['auth']) {
        this.$router.push({path: "/users/login"});
      }

      
      this.fechJobs();
      
      setInterval(() => {
        this.fechJobs();
        

        /*if(localStorage.getItem('jobs')) {
          let jobs = JSON.parse(localStorage.getItem('jobs'));
          let tmp_jobs = [];
          if(jobs.length > 0) {
            jobs.forEach((job) => {
              this.axios.get(this.base_url + '/job/'+ job._id + '/').then((response) => { 
                if(response.data.status && response.data.status != "DONE" ) tmp_jobs.push(response.data);
                
              });
            });
          
          } else {
            tmp_jobs = null;
            
          }
          this.jobs = tmp_jobs;
        }*/
      }, 5000);

      this.initScrollbar()
    }
  };
</script>
<style lang="scss">

  .nav-link-text {
    font-weight: 600;
    font-size: 1.1em;

  }

.router-link-exact-active .nav-link-text {
   font-weight: 600;

  }

  .navbar-vertical.navbar-expand-xs .navbar-nav > .nav-item > .nav-link.active {
    background: #003c50;
    color: white;

    .text-primary {
      color: white !important;
    }
  }
</style>
